module.exports = __webpack_public_path__ + "img/27_59.f30bdade.png";